/**
 * this file contains all redux-saga watchers & workers for the profile
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Min on 12/08/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'
import Cookies from 'js-cookie'

import C from '../constants'
import config from '../config'
import { request, isEmpty } from '../utility/utilities'
import {stopSubmit} from 'redux-form'

// import action creators
import * as ProfileActions from '../actions/profileActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE PROFILE DATA
----------------------------------------------------------------------------- */

// watcher saga for fetching the profile data
export function* watchFetchProfile() {
    yield takeEvery(C.FETCH_PROFILE_DATA, workerFetchProfile)
}

// worker saga for fetching the profile data
function* workerFetchProfile() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.profileFetchURL

    try {

        // show the loader
        yield put(ProfileActions.showProfileLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            const profileData = response.data

            // set the profile data
            yield put(ProfileActions.setProfileData(profileData))
        }

    } catch (error) {

        // TODO : ??

    } finally {

        // hide the loader regardless
        yield put(ProfileActions.showProfileLoader(false))
    }
}

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO UPDATE PROFILE
----------------------------------------------------------------------------- */

// watcher saga for update the profile
export function* watchUpdateProfile() {
    yield takeEvery(C.UPDATE_PROFILE, workerUpdateProfile)
}

// worker saga for update the profile
function* workerUpdateProfile(action) {

    const profileData = action.payload

    // set the headers
    const headers = {
        method: 'POST',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            'X-CSRFToken': Cookies.get('csrftoken')
        },
        data: profileData,
        mode: 'cors',
        cache: 'default',
        body: JSON.stringify(profileData)
    }

    // set the endpoint
    const requestURL = config.endpoints.profileUpdateURL

    try {
        // show the loader
        yield put(ProfileActions.showProfileLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            const profileData = response.data

            // set the profile data
            yield put(ProfileActions.setProfileData(profileData))

            // change isEditing to false
            yield put(ProfileActions.editProfile(false))
        }

    } catch (error) {
        // set form validation error
        yield put(stopSubmit('profileForm', error))
    } finally {
        // hide the loader regardless
        yield put(ProfileActions.showProfileLoader(false))
    }
}



// WEBPACK FOOTER //
// ./src/sagas/profileSaga.js